export enum BulkUpdateType {
    STATUS = 'STATUS',
    PRICE = 'PRICE',
    PATCH = 'PATCH',
}
